module.exports = __webpack_public_path__ + "static/media/quiz_male_icon_active.8c641868.svg";